import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMenuSharp } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";

import "./index.css";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

const Navbar = () => {
  const [isOpenMenu, setMenu] = useState(false);
  const {
    homeRef,
    coursesRef,
    successStoriesRef,
    activeRoute,
    setActiveRoute,
    activeSection,
    setActiveSection,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (ref) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  //stop screen scrolling when nav options are opened
  useEffect(() => {
    if (isOpenMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpenMenu]);

  const onSetMenuBar = () => {
    setMenu(!isOpenMenu);
  };

  const getActiveSection = (path, currentPath) => {
    return activeRoute === path ? "active-nav-link" : "not-active-link";
  };

  return (
    <React.Fragment>
      <header className="navbar-container shadow d-flex align-items-center fixed-top">
        <Link to={"/"} className="nav-logo-link">
          <div className="d-flex align-items-center">
            <img
              className="company-logo"
              src="https://iqteche.in/static/media/wl_client_images/703d5447d6bd49999575f2794063b574.png"
              alt="company-logo"
            />
            <h1 className="nav-heading">
              IBIX Qodify
              <br />
              <span className="nav-tech-text">Technologies</span>
            </h1>
          </div>
        </Link>

        <ul className="nav-opt-list-container ml-auto d-none d-lg-flex ">
          <Link to="/" className="nav-link-item">
            <li
              id="home"
              onClick={() => {
                scrollToSection(homeRef);
                setActiveSection("home");
                setActiveRoute("/");
              }}
              className={getActiveSection("/", location.pathname)}
            >
              Home
            </li>
          </Link>

          <li
            id="Courses"
            onClick={() => {
              scrollToSection(coursesRef);
              setActiveSection("courses");
              setActiveRoute("/courses");
            }}
            className={
              activeRoute === "/courses" || activeSection === "courses"
                ? "active-nav-link"
                : ""
            }
          >
            Courses
          </li>

          <li
            id="SuccessStories"
            onClick={() => {
              scrollToSection(successStoriesRef);
              setActiveSection("success-stories");
              setActiveRoute("/success-stories");
            }}
            className={
              activeRoute === "/success-stories" ||
              activeSection === "success-stories"
                ? "active-nav-link"
                : ""
            }
          >
            Success Stories
          </li>

          <Link className="nav-link-item" to={"/careers"}>
            <li
              id="Careers"
              className={getActiveSection("/careers", location.pathname)}
            >
              Careers
            </li>
          </Link>

          <Link className="nav-link-item" to={"/services"}>
            <li
              id="Services"
              className={getActiveSection("/services", location.pathname)}
            >
              Our Services
            </li>
          </Link>

          <li>
            <a
              href="https://learning.ibixqt.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="login-btn"
            >
              Login
            </a>
          </li>
        </ul>
        {!isOpenMenu ? (
          <div
            className="menu-icon-container ms-auto d-lg-none"
            onClick={onSetMenuBar}
          >
            <IoMenuSharp className="menu-icon" />
          </div>
        ) : (
          <div
            className="menu-icon-container ms-auto d-lg-none"
            onClick={onSetMenuBar}
          >
            <RxCross2 className="menu-icon" />
          </div>
        )}
      </header>

      {isOpenMenu && <div className="menu-overlay" />}

      <ul
        className={`custom-nav-menu d-lg-none ${isOpenMenu ? "show" : "hide"}`}
      >
        <button className="close-btn" onClick={() => setMenu(false)}>
          ×
        </button>

        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/" id="home-sm">
            Home
          </Link>
        </li>
        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/about-us" id="about-sm">
            About Us
          </Link>
        </li>

        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/courses/fullstack" id="Courses-sm">
            Full Stack Course
          </Link>
        </li>
        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/courses/specializations" id="Success_Stories-sm">
            Specializations - AI/ML, DS,...
          </Link>
        </li>
        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/courses/tech-tools" id="tech-tools-sm">
            Tech SPARK
          </Link>
        </li>
        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/careers" id="Careers-sm">
            Careers
          </Link>
        </li>
        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/services" id="services-sm">
            Our Services
          </Link>
        </li>

        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <a
            href="https://learning.ibixqt.in/"
            target="_blank"
            rel="noopener noreferrer"
            id="login-sm"
          >
            Login
          </a>
        </li>

        <li className="nav-link-item" onClick={() => setMenu(false)}>
          <Link to="/terms-and-privacy" id="terms-and-conditions-us-sm">
            Terms & Conditions
          </Link>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default Navbar;
